import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$workspaceSlug/settings/')({
  beforeLoad: ({ params }) => {
    throw redirect({ params, to: '/$workspaceSlug/settings/general' })
  },
})
